import React from 'react';
import { Box, Typography, Avatar, Paper } from '@mui/material';
import { Person } from '../../types/person';

interface PersonCardProps {
    person: Person;
    onSelect: () => void;
    isSelected: boolean;
}

const PersonCard: React.FC<PersonCardProps> = ({ person, onSelect, isSelected }) => {
    const getInitials = (name: string) => {
        const names = name.split(' ');
        const first = names[0]?.[0] || '';
        const last = names.length > 1 ? names[names.length - 1]?.[0] || '' : '';
        return `${first}${last}`.toUpperCase();
    };

    return (
        <Paper
            variant="outlined"
            onClick={onSelect}
            sx={{
                p: 1.25,
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
                transition: 'background-color 0.2s, border-color 0.2s',
                '&:hover': {
                    backgroundColor: 'action.hover',
                    borderColor: 'primary.light'
                },
                borderRadius: '6px',
                borderColor: isSelected ? 'primary.main' : 'divider',
                borderBottomLeftRadius: isSelected ? 0 : '6px',
                borderBottomRightRadius: isSelected ? 0 : '6px',
                ...(isSelected && { borderBottom: 'none' })
            }}
        >
            <Avatar sx={{ bgcolor: 'primary.main', width: 28, height: 28, mr: 1.5, fontSize: '0.7rem' }}>
                {getInitials(person.name)}
            </Avatar>
            <Box>
                <Typography component="div" sx={{ fontWeight: 'bold', fontSize: '0.8rem', lineHeight: 1.3 }}>
                    {person.name}
                </Typography>
                <Typography variant="caption" color="text.secondary" sx={{ display: 'flex', gap: 1.25, flexWrap: 'wrap', fontSize: '0.7rem' }}>
                    {person.current_role && (
                        <Box component="span">
                            <strong>Cargo:</strong> {person.current_role}
                        </Box>
                    )}
                    {person.current_level && (
                        <Box component="span">
                            <strong>Nível:</strong> {person.current_level}
                        </Box>
                    )}
                    {person.current_directorate && (
                        <Box component="span">
                            <strong>Diretoria:</strong> {person.current_directorate}
                        </Box>
                    )}
                    {!person.current_role && (
                         <Box component="span">
                            {person.email}
                        </Box>
                    )}
                </Typography>
            </Box>
        </Paper>
    );
};

export default PersonCard;
